import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import Swal from 'sweetalert2';
import { APP_CONFIG, IAppConfig } from '../../app.config/app.config';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { StorageService } from 'src/app/services/shared/storage.service';
import { Translators } from 'src/app/services/shared/translators.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-activate-account',
    templateUrl: './activate-account.component.html',
    styleUrls: ['./activate-account.component.scss'],
})
export class ActivateAccountComponent implements OnInit {
    form: FormGroup;
    siteKey: string;
    showPin: boolean;
    emailActivar: string = null;
    pinActivar: string = null;
    idioma: Subscription;

    constructor(
        private authservice: AuthService,
        private router: Router,
        @Inject(APP_CONFIG)
        private iAppConfig: IAppConfig,
        private route: ActivatedRoute,
        private guiMsjService: GuiMsjService,
        private storageService: StorageService,
        private translatorService: Translators
    ) {
        // this.getEmailActivar();
        this.idioma = this.translatorService
            .getIdiomaSeleccionado()
            .subscribe((resp) => {
                this.idioma = resp;
            });
    }

    ngOnInit() {
        this.obtenerParametros();
        this.setSiteKey(this.iAppConfig.recaptcha.siteKey);
    }

    useLanguage(idioma: string) {
        this.translatorService.setIdiomaSeleccionado(idioma);
    }

    async obtenerParametros() {
        this.route.queryParamMap.subscribe((params) => {
            this.pinActivar = params.get('pin');
            this.emailActivar = params.get('email');

            this.createForm();

            this.form.controls['recaptcha'].enable();

            this.confirmAccount();

        });
    }
    async getEmailActivar() {
        return this.storageService.getEmailActivar().then((email: string) => {
            this.emailActivar = email.replace('"', '');
            //   alert(email.toString())
        });
    }

    setSiteKey(key: string) {
        this.siteKey = key;
    }

    get emailNoValido() {
        return this.form.get('email').invalid && this.form.get('email').touched;
    }

    get pinNoValido() {
        return this.form.get('pin').invalid && this.form.get('pin').touched;
    }

    validateTokenActivate() {
        const token = this.authservice.validateToken();
        if (!token) {
            this.router.navigateByUrl('/profile-authentication');
        }
    }

    createForm() {
        this.form = new FormGroup({
            email: new FormControl(this.emailActivar, [
                Validators.required,
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
            ]),
            pin: new FormControl(this.pinActivar, [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(8),
            ]),
            recaptcha: new FormControl('', Validators.required),
        });

        this.form.controls['recaptcha'].disable();
    }

    async confirmAccount() {
        await this.guiMsjService.msjFormSubmit('Espere');
        Swal.showLoading();
        this.authservice.confirmAccount(await this.setDataForma());
    }

    async setDataForma() {
        const data: any = {
            email: this.form.value.email,
            pin: this.form.value.pin,
        };

        return data;
    }
}
